import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BillingPage } from "@/features/billing/billing-page";

/**
 * /app/billing — plan status, self-service (cancel / resume / portal / withdrawal) and the paywall.
 * `checkout` is set by the provider's success redirect; `feature`/`limit`/`plan` by an UpgradePrompt
 * (`plan` = the tier a refused feature lives on, so the offer opens on that tier).
 */
const search = z.object({
  // Paddle appends its own params (transaction_id, customer_email, paddle_customer_id) and a mistyped success URL
  // once arrived as "success." — normalise instead of throwing the visitor onto the error page.
  checkout: z
    .string()
    .optional()
    .transform((v) => (v?.startsWith("success") ? "success" : v?.startsWith("cancel") ? "cancelled" : undefined))
    .pipe(z.enum(["success", "cancelled"]).optional()),
  feature: z.string().optional(),
  limit: z.coerce.number().optional(),
  plan: z.enum(["premium", "pro", "enterprise"]).optional(),
});

export const Route = createFileRoute("/app/billing")({ validateSearch: search, component: BillingPage });
